import { callApi } from 'utils/api';

export function linksFetch() {
  return callApi('/more/links');
}




/** WEBPACK FOOTER **
 ** ./src/members/state/links/api.js
 **/